export const analytics = {
  All: {
    budgetDistribution: {
      categories: ["Almas", "Apoena", "Aranzazu", "BR009", "BR012"],
      series: [
        {
          name: "Budget",
          data: [69.65950961901785, 3.021069401360091, 1.36457677262497, 0, 25.95484420699708]
        }
      ]
    },
    finance: {
      amount: 149204671.85,
      belowTarget: 0.7821022362739477,
      labels: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
      series: [
        {
          name: "actual",
          data: [
            6842707.68, 9592410.5, 9004856.97, 8803033.16, 9558292.36,
            15860368.8, 18798380.71, 17257566.09, 16447939.93, 16763205.21,
            15308132.32, 4967778.12
          ]
        }
      ]
    },
    drilling: {
      meters: 64901.4301,
      belowTarget: null,
      labels: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
      series: [
        {
          name: "meters",
          data: [
            1416.11, 4663.93, 4483.76, 5827.37, 6247.34,
            5005.08, 6174.55, 9553.29, 7037.6101, 7191.89, 6810.5, 490
          ]
        }
      ]
    },
    budgetDetails: {
      columns: ["site", "budget", "meters","monthDrilled", "lastWeekDrilled"],
      rows: [
        {
          id: 1,
          siteName: "Apoena",
          actual: 0,
          budget: 16354000,
          diff: -1,
          actualmeters: 17061,
          budgetmeters: 17061,
          drillingdiff: -1,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 2,
          siteName: "Almas",
          actual: 384000,
          budget: 384000,
          diff: 0,
          actualmeters: 16989,
          budgetmeters: 16989,
          drillingdiff: 0,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 3,
          siteName: "Aranzazu",
          actual: 4050379.49,
          budget: 4050379.49,
          diff: 0,
          actualmeters: 10,
          budgetmeters: 33739.38,
          drillingdiff: -0.9997036104397887,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 4,
          siteName: "Matupá",
          actual: 32019,
          budget: 32019,
          diff: 0,
          actualmeters: 15825,
          budgetmeters: 15825,
          drillingdiff: 0,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 5,
          siteName: "Minosa",
          actual: 24221210.96,
          budget: null,
          diff: null,
          actualmeters: 3.04,
          budgetmeters: 44985.84,
          drillingdiff: -0.9999324231802719,
          monthdrilled: null,
          weekdrilled: null
        }
      ]
    },
    SiteCostByAccount: {
      columns: ["site", "budget", "meters","monthDrilled", "lastWeekDrilled"],
      rows: [
        {
          id: 1,
          siteName: "Insumos de Operación",
          actual: 0,
          budget: 16354000,
          diff: -1,
          actualmeters: 17061,
          budgetmeters: 17061,
          drillingdiff: -1,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 2,
          siteName: "Almas",
          actual: 384000,
          budget: 384000,
          diff: 0,
          actualmeters: 16989,
          budgetmeters: 16989,
          drillingdiff: 0,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 3,
          siteName: "Aranzazu",
          actual: 4050379.49,
          budget: 4050379.49,
          diff: 0,
          actualmeters: 10,
          budgetmeters: 33739.38,
          drillingdiff: -0.9997036104397887,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 4,
          siteName: "Matupá",
          actual: 32019,
          budget: 32019,
          diff: 0,
          actualmeters: 15825,
          budgetmeters: 15825,
          drillingdiff: 0,
          monthdrilled: 0,
          weekdrilled: 0
        },
        {
          id: 5,
          siteName: "Minosa",
          actual: 24221210.96,
          budget: null,
          diff: null,
          actualmeters: 3.04,
          budgetmeters: 44985.84,
          drillingdiff: -0.9999324231802719,
          monthdrilled: null,
          weekdrilled: null
        }
      ]
    },
    ActualxBudgetFinancial: {
      labels: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
      series: [
        {
          name: "budget",
          type: "line",
          data: [
            2852417.09, 7948582.43, 8495798.56, 16269064.73, 5710525.36,
            7107529.72, 8737204.8, 6793960.02, 7993049.82, 5306890.02,
            5907690.64, 601255.51
          ]
        },
        {
          name: "actual",
          type: "column",
          data: [
            6842707.68, 9592410.5, 9004856.97, 8803033.16, 9558292.36,
            15860368.8, 18798380.71, 17257566.09, 16447939.93, 16763205.21,
            15308132.32, 4967778.12
          ]
        }
      ]
    },
    ActualxBudgetMeters: {
      labels: [],
      series: [
        { name: "budget", type: "line", data: [] },
        {
          name: "actual",
          type: "column",
          data: [
            1416.11, 4663.93, 4483.76, 5827.37, 6247.34,
            5005.08, 6174.55, 9553.29, 7037.6101, 7191.89, 6810.5, 490
          ]
        }
      ]
    },
    drillingStatus: {
      events: [
        {
          status: "done",
          UpdateAt: "2024-02-02T12:32:02.836",
          holeName: "SMG-009",
          siteName: "Almas",
          subSiteName: "São Miguel"
        }
      ]
    }
  }
};